/**
 * Check if the current user has the adequete permissions to view the given menu item
 *
 * @param {object} menuItem - the specific menu item that the user needs to be authorized to view
 * @param {object} appContext - the context with the current users permission data
 */
export function isAuthorizedForMenuItem(menuItem, appContext) {
	return menuItem.permissions.filter(x => appContext.user[x] === true).length !== 0;
}
